import { tv } from '@change/ds-utils';

export const BodyStyles = tv({
	base: 'bg-background-base flex flex-col',
	variants: {
		size: {
			xsmall: 'h-full w-full',
			small: 'max-h-[185px] w-full gap-1',
			medium: 'max-h-[360px] w-full gap-2.5',
			large: 'max-h-[416px] w-full gap-3',
		},
	},
});

export const BodyTextStyles = tv({
	base: 'tracking-0 overflow-hidden whitespace-pre-wrap font-[Arial] leading-[140%]',
	variants: {
		size: {
			xsmall: 'max-h-[97px] px-[5px] text-[5px]',
			small: 'max-h-[97px] px-[5px] text-[5px]',
			medium: 'max-h-[205px] px-2.5 text-[10px]',
			large: 'max-h-[238px] px-3 text-[12px]',
		},
	},
});

export const BodyImageStyles = tv({
	base: 'object-fill',
	variants: {
		size: {
			xsmall: 'h-auto w-full',
			small: 'h-auto w-full',
			medium: 'h-auto w-full',
			large: 'h-auto w-full',
		},
	},
});
